module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Light-df0f59d80526acc6d0cd31413184263f.woff";